import { render, staticRenderFns } from "./PracticeSettings.vue?vue&type=template&id=3afc56e6&scoped=true&"
import script from "./PracticeSettings.vue?vue&type=script&lang=js&"
export * from "./PracticeSettings.vue?vue&type=script&lang=js&"
import style0 from "./PracticeSettings.vue?vue&type=style&index=0&id=3afc56e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc56e6",
  null
  
)

export default component.exports